import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_budget_generic_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  budget_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  fi_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  foreign_ccy: boolean;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
  base_doc_line_xrate: fromDatatype.VarcharDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  amount_txn;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_desc: fromDatatype.VarcharDatatypeInterface;
  item_remarks: fromDatatype.VarcharDatatypeInterface;
  item_reference_no: fromDatatype.VarcharDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  line_option_json;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  client_data_source: fromDatatype.VarcharDatatypeInterface;
  client_item_guid: fromDatatype.GuidDataFieldInterface;
  client_item_code: fromDatatype.VarcharDatatypeInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_hashed_value: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  xtn_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  xtn_process_status_guid: fromDatatype.GuidDataFieldInterface;
  xtn_process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  xtn_workflow_updated_at: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_to_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_from_guid: fromDatatype.GuidDataFieldInterface;
  adjustment: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_budget_generic_doc_line_RowClass
  implements bl_fi_budget_generic_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  budget_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  fi_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  foreign_ccy: boolean;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
  base_doc_line_xrate: fromDatatype.VarcharDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  amount_txn: any;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_desc: fromDatatype.VarcharDatatypeInterface;
  item_remarks: fromDatatype.VarcharDatatypeInterface;
  item_reference_no: fromDatatype.VarcharDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  line_option_json: any;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  client_data_source: fromDatatype.VarcharDatatypeInterface;
  client_item_guid: fromDatatype.GuidDataFieldInterface;
  client_item_code: fromDatatype.VarcharDatatypeInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_hashed_value: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  xtn_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  xtn_process_status_guid: fromDatatype.GuidDataFieldInterface;
  xtn_process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  xtn_workflow_updated_at: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_to_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_from_guid: fromDatatype.GuidDataFieldInterface;
  adjustment: fromDatatype.VarcharDatatypeInterface;
}
